export default defineNuxtRouteMiddleware(() => {
  const { user } = useAuth();

  if (!user?.landlord?.holding_agreements_enabled) {
    return navigateTo('/utilities');
  }
});
